import Axios from '../api/axios';
import notify from '../utils/notifyUtil';
import Dict from '../messages';
import * as glb from '../globals';
import cariModelStore from '../store/cariModelStore';
import { isTempId } from './tempIdUtils';

const pnm = 'CARI_KART';
const cid = () => glb.default?.KULLANICI?.KUL_DEF_FIR_REF;

/**
 * Arka planda cari kartı server'a gönder (asenkron)
 * Hata durumunda kullanıcıya sekme/alan bilgisi ile uyarı
 */
export async function syncCarikart(carKey, options = {}) {
  const { sekme = 'Cari Bilgileri', onSuccess, onError } = options;
  const model = cariModelStore.getModel(carKey);
  if (!model) {
    onError?.(new Error('Model bulunamadı'));
    return;
  }

  const data = { ...model.carikart, cariAramaList: model.cariAramaList };
  const isNew = isTempId(data.CAR_REF);

  try {
    const payload = {
      data,
      type: 'save',
      pnm,
      uid: glb.default?.KULLANICI?.KUL_REF,
      vid: 1,
      cid: cid(),
      defcid: cid(),
      isource: 1,
      lang: glb.default?.KULLANICI?.KUL_DILKOD,
      inip: '??',
    };

    const res = await Axios.post(
      `${process.env.REACT_APP_BACKEND_SERVER}${pnm}/save`,
      payload
    );

    if (res?.data?.iserr === true) {
      const msg = res.data.errmsg || Dict.get('serverError');
      notify(
        `Cari kartınızın "${sekme}" sekmesinde işlem başarısız: ${msg}`,
        'error',
        4000
      );
      cariModelStore.getModel(carKey)?.meta && (cariModelStore.getModel(carKey).meta.syncError = msg);
      onError?.(new Error(msg));
      return;
    }

    const savedCarRef = res?.data?.CAR_REF ?? res?.data?.carikart?.CAR_REF ?? res?.data?.carikart?.car_ref;
    if (isNew && savedCarRef != null) {
      cariModelStore.resolveTempId(carKey, data.CAR_REF, savedCarRef);
    }
    const savedRow = res?.data?.carikart;
    const savedKey = isNew ? savedCarRef : carKey;
    if (savedRow && typeof savedRow === 'object' && savedKey != null) {
      cariModelStore.updateCarikart(savedKey, savedRow);
    }
    cariModelStore.clearChanged(isNew ? savedCarRef : carKey);
    notify(Dict.get('Cari Kaydedildi'), 'success', 2000);
    onSuccess?.(res?.data);
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || String(err);
    notify(
      `Cari kartınızın "${sekme}" sekmesinde işlem başarısız: ${msg}`,
      'error',
      4000
    );
    const m = cariModelStore.getModel(carKey);
    if (m?.meta) m.meta.syncError = msg;
    onError?.(err);
  }
}

/**
 * Arka planda arama kaydını server'a gönder
 */
export async function syncArama(carKey, arama, options = {}) {
  const { sekme = 'Arama', onSuccess, onError } = options;

  try {
    const res = await Axios.post(
      `${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/arakaydet?cid=${cid()}`,
      arama
    );

    if (res?.data?.iserr === true) {
      const msg = res.data.errmsg || Dict.get('serverError');
      notify(
        `Cari kartınızın "${sekme}" sekmesinde işlem başarısız: ${msg}`,
        'error',
        4000
      );
      onError?.(new Error(msg));
      return;
    }

    const saved = res?.data?.saved;
    if (saved) {
      const savedRef = saved.CD_REF ?? saved.cd_ref;
      const tempRef = arama.CD_REF ?? arama.cd_ref;
      if (isTempId(tempRef) && savedRef != null) {
        const model = cariModelStore.getModel(carKey);
        if (model) {
          const idx = model.cariAramaList.findIndex((r) => (r.CD_REF ?? r.cd_ref) === tempRef);
          if (idx >= 0) {
            const arr = [...model.cariAramaList];
            arr[idx] = { ...arr[idx], ...saved, CD_REF: savedRef };
            cariModelStore.setCariAramaList(carKey, arr);
          }
        }
      }
    }
    notify(Dict.get('Kaydedildi'), 'success', 2000);
    onSuccess?.(res?.data);
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || String(err);
    notify(
      `Cari kartınızın "${sekme}" sekmesinde işlem başarısız: ${msg}`,
      'error',
      4000
    );
    onError?.(err);
  }
}
